import React from 'react'
import { Grid, Stack, styled } from '@mui/material'
import { rootUrl, usageHistoryUrl } from '../../containers/common/constant/appUrl'
import { getReservationStatusSearchConditions } from '../../containers/common/codeMaster'
import { tabValue, useAction } from '../../containers/reservationStatusList/reservationStatusListService'
import { getClassificationValueLabels, translate } from '../../i18n'
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { ButtonOutlinedResponsive } from '../components/common/buttons/buttonOutlinedResponsive'
import { MiddleItem } from '../components/common/gridItems'
import { RadioButtonGroupNoBind } from '../components/common/inputs/radioButtonGroupNoBind'
import { SelectNoBind } from '../components/common/inputs/selectNoBind'
import { Link } from '../components/common/link'
import { ReservationCard } from '../components/common/reservation/reservationCard'
import { LotteryReservationCard } from '../components/common/lotteryReservation/lotteryReservationCard'
import { TabBar } from '../components/common/tabBar'
import { InterviewCard } from '../components/reservationStatusList/interviewCard'
import { AcceptNoticeCard } from '../components/acceptNotice/acceptNoticeCard'

const SeparateString = '／'

const NoResultMessageCard = styled('div')({
  padding: '20px 0',
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
})

export const ReservationStatusList: React.FC = () => {
  const {
    activeChildId,
    activeTabValue,
    activeStatusSearchCondition,
    reservations,
    lotteryReservations,
    interviews,
    batchResults,
    childs,
    tabs,
    projects,
    acceptNoticeStatus,
    changeChild,
    changeTab,
    statusSearchConditionChangeHandle
  } = useAction();

  let contents
  if (reservations) {
    contents = reservations.map((reservation) => <ReservationCard key={reservation.reservationNo} {...reservation} />)
  } else if (interviews) {
    contents = interviews.map((interview) => <InterviewCard key={interview.interviewNo} {...interview} />)
  } else if (lotteryReservations){
    contents = lotteryReservations.map((reservation) => <LotteryReservationCard key={reservation.lotteryReservationNo} {...reservation} />)
  } else if (batchResults) {
    contents = batchResults.map((batchResult) => <AcceptNoticeCard key={batchResult.batchId} {...batchResult} />)
  }
  
  /** タブ名称ラベル、タブ内０件メッセージ表示内容を設定 */
  // このサイト内 全事業マスタの全履歴内に施設申込方法（0:面談申込 1:事前申込）の設定状況により表示を切り替える
  const interviewMethodAllZero = projects.filter(project => project.interviewMethodFlag === '1').length > 0 ? false : true

  // タブ名称ラベル
  const tabNameString = getClassificationValueLabels(
    'reservationStatusList.classification.tabValue',
    tabs
  )

  const repTabName: {value: string; label: string;}[] = []
  for (const user of tabNameString) {
    if ((acceptNoticeStatus === '1' || acceptNoticeStatus === '2') && user.value === '4') {
      continue
    }

    if(user.value === '3') {
      const strRepValues = user.label.split(SeparateString)
      const strValue = interviewMethodAllZero ? strRepValues[0] : strRepValues[1]
      const repUser: {value: string; label: string;} = user
      
      // repUser = user
      repUser.label = strValue
      repTabName.push(repUser);
    } else {
      repTabName.push(user);
    }
  }

  // タブ内０件メッセージ
  const getNoDataMessage = () => {
    let noDataMessageKey: string;

    if (activeTabValue === tabValue.reservation) {
      noDataMessageKey = 'reservationStatusList.text.noReservation';
    } else if (activeTabValue === tabValue.interview) {
      if (interviewMethodAllZero) {
        noDataMessageKey = 'reservationStatusList.text.noInterview';
      } else {
        noDataMessageKey = 'reservationStatusList.text.noInterviewAdvance';
      }
    } else if (activeTabValue === tabValue.lotteryReservation) {
      noDataMessageKey = 'reservationStatusList.text.noLotteryReservation';
    } else if (activeTabValue === tabValue.acceptNotice) {
      noDataMessageKey = 'reservationStatusList.text.noAcceptNotice';
    } else {
      noDataMessageKey = 'reservationStatusList.text.noData';
    }

    return translate(noDataMessageKey);
  }

  if (contents == null) {
    return null
  }

  return (
    <Stack spacing={2}>
      <Grid container>
        <Grid item md={3}></Grid>
        <Grid item xs={12} md={6}>
          <Grid container rowSpacing={1}>
            {/** お子様選択 */}
            <MiddleItem item>{translate('reservationStatusList.label.selectionChild')}</MiddleItem>
            <Grid item xs ml={1}>
              <SelectNoBind
                fullWidth
                includeNone="always"
                noneLable={translate('system.pulldown.allChildren')}
                valueLabels={childs}
                onChange={changeChild}
                value={activeChildId}
              />
            </Grid>
            {/* 予約状況確認画面へのリンク */}
            <Grid my={1} justifyContent="end" spacing={1} container>
              <Grid item>
                <Link to={usageHistoryUrl.url()}>{translate('reservationStatusList.label.usageHistoryCheck')}</Link>
              </Grid>
            </Grid>
            {/** タブ選択 */}
            <Grid item xs={12}>
              <TabBar
                value={activeTabValue}
                valueLabels={repTabName}
                onChange={changeTab}
              />
            </Grid>
            {/** 検索項目 */}
            {activeTabValue === tabValue.reservation && (
              <Grid item xs={12}>
                <RadioButtonGroupNoBind 
                  name={'statusSearchCondition'}
                  value={activeStatusSearchCondition}
                  onChange={statusSearchConditionChangeHandle}
                  buttonValueLabels={getReservationStatusSearchConditions()}
                  row
                />
              </Grid>
            )}
            {/** 予約カード */}
            <Grid item xs={12}>
              <Stack spacing={1}>
                {contents.length ? (
                <Stack spacing={1}>{contents}</Stack>
              ) : (
                <NoResultMessageCard>
                  {getNoDataMessage()}
                </NoResultMessageCard>
              )}
              </Stack>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={3}></Grid>
      </Grid>
      <BottomButtonGroup>
        <ButtonOutlinedResponsive to={rootUrl.url()}>{translate('system.button.backToHome')}</ButtonOutlinedResponsive>
      </BottomButtonGroup>
    </Stack>
  )
}
